(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('kebabCase', kebabCase);

    function kebabCase(lodash) {
        return function(value) {
            return lodash.kebabCase(value);
        }
    }
})();